import type { CampaignOverviewModel } from './overview';

/** The general question every campaign can ask. */
const GENERAL_QUESTION = 'What do people say most often?';

/** A label quoted inside a question, without its own trailing question mark. */
function quoted(label: string): string {
  return `“${label.trim().replace(/\?+$/, '')}”`;
}

/**
 * Up to 3 Ask hollie suggestions built from the campaign's own questions with
 * fixed templates: the first highlighted choice, the strongest numeric pair,
 * and one general question.
 */
export function buildSuggestions(model: CampaignOverviewModel): string[] {
  const suggestions: string[] = [];
  const choice = model.highlights.find(summary => summary.kind === 'distribution');
  if (choice) suggestions.push(`What stands out in ${quoted(choice.label)}?`);
  const [pair] = model.relationships.suggested;
  if (pair) suggestions.push(`How does ${quoted(pair.a.question.label)} relate to ${quoted(pair.b.question.label)}?`);
  suggestions.push(GENERAL_QUESTION);
  return suggestions;
}

/** The question a card's Ask hollie link sends. */
export function questionPrompt(label: string): string {
  return `Tell me more about ${quoted(label)}`;
}
